// 操作ログの発生元アプリ判別
// fork_webapp_react 以外のアプリ (ポールマップ編集v2 など) は、送信時に
// context.app へアプリIDを付与する。付与が無いログは webapp 由来とみなす。

import type { FrontendLog } from '@/types/frontendLog'

export const APP_LABELS: Record<string, string> = {
  polemap_v2: 'ポールマップ編集',
}

/** ログの context.app (無ければ null = webapp 由来) */
export function getAppId(log: FrontendLog): string | null {
  const app = log.context?.app
  return typeof app === 'string' ? app : null
}

/** webapp 以外のアプリの表示ラベル (webapp 由来は null) */
export function getAppLabelFromLog(log: FrontendLog): string | null {
  const app = getAppId(log)
  if (!app) return null
  return APP_LABELS[app] ?? app
}
